<template>
  <div>
    <div v-if="!showError" class="cert-home-graphics" :class="fade">
      <div class="cert-type">
        <div class="cert-text">Articles</div>
      </div>
      <div v-if="items!=null" class="cert-img-container">
        <div class="cert-backdrop"></div>
        <div class="cert-img">
          <img :src="`${baseUrl}proxy/${horusBase64.stringToBase64URLSafe(items[activeIndex].images[0].url)}`"/>
        </div>
      </div>
      <div v-if="items!=null" class="cert-data">
        <div class="cert-title"
             @click="()=>$router.push({name:'Alert',params:{id:items[activeIndex].uid,type:'news_events'}})">
          <div class="cert-text col-9 mx-auto" v-html="items[activeIndex].title"></div>
        </div>
        <div class="cert-pagination d-flex flex-row col-9 mx-auto">
          <div v-for="(item,index) in items" :key="index" class="cert-item"
               :class="activeIndex===index?'active':''"
               @click="next(index)"></div>
        </div>
      </div>
      <div v-if="items!=null" class="cert-accent d-none d-md-inline"></div>
      <cert-progress-indicator v-if="items==null"/>
    </div>
  </div>
</template>

<script>
import CertProgressIndicator from "@/views/cert/components/CertProgressIndicator";
import api from '../../../api.js';
import horusBase64 from "@/components/horusBase64";

export default {
  name: "CertAlertCaroussel",
  computed: {
    horusBase64() {
      return horusBase64
    }
  },
  components: {
    CertProgressIndicator,
  },
  data() {
    return {
      fade: "",
      activeIndex: -1,
      items: null,
      showError: false,
      baseUrlCyber: process.env.VUE_APP_BASE_URL_CYBER,
      baseUrl: process.env.VUE_APP_BASE_URL,
    }
  },
  created() {
    this.loadAlerts()
  },
  methods: {
    handleResponse(items) {
      this.items = items != null && items.length > 0 ? items : null;
      this.items = items?.sort((i1, i2) => i2.datetime.timestamp - i1.datetime.timestamp);
      this.items = this.items?.slice(0, Math.min(this.items?.length, 10));
      this.activeIndex = 0;
      this.startInterval();
      this.showError = false;
    },
    loadAlerts() {
      api
          .get(`${process.env.VUE_APP_BASE_URL}proxy/${horusBase64.stringToBase64URLSafe("api/news_events")}`)
          .then((response) => {
            this.handleResponse(response?.data?.items);
          })
          .catch((error) => {
            error;
            console.error(error)
            this.showError = true;
          });
    },
    next(index) {
      if (index != null)
        this.startInterval();
      this.fade = "fade-out-left";
      setTimeout(() => {
        this.fade = "set-right"
      }, 300);

      setTimeout(() => {
        this.activeIndex = index == null ? (this.activeIndex + 1) % this.items.length : index;
        this.fade = "";
      }, 400);
    },
    startInterval() {
      if (this.interval != null)
        clearInterval(this.interval);
      this.interval = setInterval(() => {
        this.next();
      }, 8600);
    }
  },

}
</script>